import { defineMessages } from 'react-intl';

export default defineMessages({
  uploadAssetError: {
    id: 'app.containers.Assets.uploadAssetError',
    defaultMessage: 'Error uploading file. Try again later.',
  },
});
